import { senseCheckOrgDates } from '../lib/dateChecks';

/**
 * DateSenseChecks
 * ---------------
 * Renders inline notes for an org's date fields against the user's DOB.
 * Silent if everything looks plausible. Severity 'warn' is an amber note,
 * 'info' is a neutral note. These are never errors — a rough memory of your
 * own life is not invalid input.
 *
 * Props:
 *  - dob, startDate, endDate, type, testIdPrefix (optional)
 */
const DateSenseChecks = ({ dob, startDate, endDate, type, testIdPrefix = 'date-check' }) => {
  const warnings = senseCheckOrgDates({ dob, startDate, endDate, type });
  if (warnings.length === 0) return null;
  return (
    <ul className="space-y-1.5" data-testid={`${testIdPrefix}-list`}>
      {warnings.map((w) => {
        const isWarn = w.severity === 'warn';
        const tone = isWarn ? 'bg-amber-wash text-amber-ink' : 'bg-inset text-ink-70';
        return (
          <li
            key={w.id}
            className={`text-sm rounded-md px-3 py-2 ${tone}`}
            data-testid={`${testIdPrefix}-${w.id}`}
          >
            {w.message}
          </li>
        );
      })}
    </ul>
  );
};

export default DateSenseChecks;
